import React from 'react';
import LegalPageShell from '../components/LegalPageShell';
import LEGAL_DETAILS from '../config/legal';
import SEO from '../components/SEO';
import { SEO_TEXTES } from '../data/seoTextes';

const essentialStorageItems = [
  'mémorisation locale de votre choix de consentement pendant 6 mois',
  'stockage technique nécessaire à l\'authentification et à l\'accès au back-office /my, lorsque vous utilisez ces services',
  'aucun cookie publicitaire ou de reciblage n\'est déposé par le site public',
];

const analyticsItems = [
  'mesure des pages consultées et des parcours de navigation',
  'analyse de la fréquentation du site pour améliorer les contenus et les parcours',
  "sans choix de votre part : mesure anonyme, sans cookie, adresse IP tronquée",
  "cookies _pk_id (13 mois) et _pk_ses (30 minutes) seulement si vous acceptez",
];

function BulletList({ items }) {
  return (
    <ul className="space-y-3">
      {items.map((item) => (
        <li key={item} className="flex gap-3 text-slate-300 leading-relaxed">
          <span className="mt-2 h-2 w-2 rounded-full bg-[#0099D6] flex-shrink-0" />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
}

export default function CookiesPage({ onManageCookies }) {
  return (
    <>
      <SEO {...SEO_TEXTES['/cookies']} path="/cookies" />
    <LegalPageShell
      testId="cookies-page"
      title={'Politique de cookies'}
      subtitle={"Le site meteris.fr limite les traceurs au strict nécessaire : mesure d'audience anonyme et sans cookie, cookies Matomo seulement si vous les acceptez, plus aucune mesure si vous refusez."}
      updatedAt={LEGAL_DETAILS.updatedAt.cookies}
    >
      <section className="rounded-3xl border border-white/5 bg-[#15171E]/70 p-8 md:p-10">
        <h2 className="text-2xl font-semibold text-white mb-4">{'Cookies essentiels et stockage local'}</h2>
        <p className="text-slate-300 leading-relaxed mb-5">
          {'METERIS utilise un stockage technique limité pour faire fonctionner le site, mémoriser votre choix concernant les cookies et sécuriser l\'accès aux espaces réservés. Ces éléments ne servent pas à la publicité.'}
        </p>
        <BulletList items={essentialStorageItems} />
      </section>

      <div className="grid gap-6 lg:grid-cols-2">
        <section className="rounded-3xl border border-white/5 bg-[#15171E]/70 p-8 md:p-10">
          <h2 className="text-2xl font-semibold text-white mb-4">{'Mesure d\'audience Matomo'}</h2>
          <p className="text-slate-300 leading-relaxed mb-5">
            {"Le site mesure sa fréquentation avec Matomo, hébergé par METERIS sur https://piwik.meteris.fr/ (identifiant de site 19). Tant que vous n'avez pas fait de choix, cette mesure est anonyme : aucun cookie n'est déposé et votre adresse IP est tronquée."}
          </p>
          <BulletList items={analyticsItems} />
        </section>

        <section className="rounded-3xl border border-white/5 bg-[#15171E]/70 p-8 md:p-10">
          <h2 className="text-2xl font-semibold text-white mb-4">Refus et modification</h2>
          <p className="text-slate-300 leading-relaxed">
            {"Vous pouvez refuser la mesure d'audience dès votre première visite : plus aucune requête n'est alors envoyée à Matomo et aucun cookie n'est déposé. Votre choix peut être modifié à tout moment depuis le bandeau cookies ou en nous écrivant à contact@meteris.fr."}
          </p>
          <p className="mt-4 text-slate-300 leading-relaxed">
            {'En cas de refus ou de retrait du consentement, la mesure d\'audience est arrêtée et les cookies Matomo déjà présents sur votre navigateur sont supprimés par le site lorsque cela est possible.'}
          </p>
        </section>
      </div>

      <section className="rounded-3xl border border-white/5 bg-[#0F1117]/90 p-8 md:p-10">
        <h2 className="text-2xl font-semibold text-white mb-4">{'Gérer vos choix'}</h2>
        <p className="text-slate-300 leading-relaxed mb-6">
          {'Le moyen le plus simple pour modifier votre préférence consiste à rouvrir le bandeau cookies. Vous pouvez également nous contacter pour toute question relative à la protection des données et à la mesure d\'audience.'}
        </p>
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
          <button
            type="button"
            onClick={onManageCookies}
            className="inline-flex items-center justify-center rounded-xl bg-[#0099D6] px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-[#0284C7]"
          >
            {'Ouvrir le bandeau cookies'}
          </button>
          <a
            href={`mailto:${LEGAL_DETAILS.contactEmail}`}
            className="inline-flex items-center justify-center rounded-xl border border-white/10 px-5 py-3 text-sm font-semibold text-slate-200 transition-colors hover:border-white/20 hover:text-white"
          >
            {LEGAL_DETAILS.contactEmail}
          </a>
        </div>
      </section>
    </LegalPageShell>
    </>
  );
}
